// extracted by mini-css-extract-plugin
module.exports = {"customScrollBar":"ProductImagePreview_customScrollBar__N419n"};